import { darken, getContrast } from 'polished';

/**
 * Darkens a colour until white text on it (and it as text on white) reaches
 * WCAG AA, 4.5:1. Community colours are set by admins, so they can be anything.
 */
export const accessibleOnWhite = (color: string, ratio = 4.5): string => {
  let result = color;
  try {
    for (let i = 0; i < 20 && getContrast(result, '#FFFFFF') < ratio; i++) {
      result = darken(0.02, result);
    }
  } catch {
    return color;
  }
  return result;
};
